module.exports = __webpack_public_path__ + "static/media/肉羹麵.ece786bc.jpg";